import { getEnvValue } from 'configs/app/utils';

const config = Object.freeze({
  baseUrl: getEnvValue('NEXT_PUBLIC_PRICE_API_HOST') || '',
});

export default config;
